/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore')
@observer
export default class ScheduleCalibrationError extends React.Component<*> {
  render(): React.Fragment {
    const {
      t,
      actionDrawerStore,
      asset,
    }: {
      t: TranslatorProps,
      actionDrawerStore: TypeActionDrawerStore,
      asset: Object,
    } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:error')}</h3>
            <h4>{t('general:assets.messages.schedule_calibration_error')}</h4>
          </div>
          <div className={styles['archive-account-details']}>
            <ul>
              <li>
                <b>{t('general:assets.labels.number')}:</b> {asset.asset_number}
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
